(function brightcovePlayer(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.VideoPlayers = global.NewHomeSource.VideoPlayers || {};

  class Brightcove {
    constructor() {
      this.brightcoveDomain = '//players.brightcove.net/';
      this.scriptFile = '_default/index.min.js';
      this.playerInformation = {
        account: '689254969001',
        player: 'HkxkXn9mf',
      };
      this.videoId = 'video-id';
      this.bcPlayer = null;
      this.eventsHandler = null;
      this.player = null;
      this.defaultEvents = {
        onEnded: function onEnded() { },
        onPlaying: function onPlaying() { },
        onPaused: function onPaused() {
        },
      };
    }

    /**
    * @param {string} source id of the video to be displayed.
    * @param {object} config with the extra information needed by the player.
    */
    initialize(source, config) {
      this.player = global.document.getElementById(source);
      this.playerInformation[this.videoId] = source;
      this.eventsHandler = Object.assign({ }, this.defaultEvents, config);
    }

    /**
    * brightcoveFilepath: returns the path where the JavaScript for the requested player can be found.
    */
    brightcoveFilepath() {
      return global.document.location.protocol +
      this.brightcoveDomain +
      this.playerInformation.account +
      '/' +
      this.playerInformation.player +
      this.scriptFile;
    }

    /**
     * setAttribute: sets the value as an attribute according to the playerInformation.
     * @param {string} value property that is going to be set in the DOM.
     */
    setAttribute(value) {
      this.player.setAttribute('data-' + value, this.playerInformation[value]);
    }

    /**
     * onPlaying: triggers the onPlaying event handler.
     */
    playingHandler(data) {
      const eventData = data;
      eventData.videoId = this.playerInformation[this.videoId];
      document.body.dispatchEvent(new CustomEvent('videoInteraction', {
        detail: { originator: 'brightcove', interaction: 'video_play' }
      }));
      this.eventsHandler.onPlaying(eventData);

      this.bcPlayer.isEventViewed = {};
    }

    /**
     * onPaused: triggers the onPaused event handler.
     */
    pausedHandler(data) {
      const eventData = data;
      eventData.videoId = this.playerInformation[this.videoId];
      document.body.dispatchEvent(new CustomEvent('videoInteraction', {
        detail: { originator: 'brightcove', interaction: 'video_pause' }
      }));
      this.eventsHandler.onPaused(eventData);

      this.bcPlayer.isEventViewed = {};
    }

    /**
     * onEnded: triggers the onEnded event handler.
     */
    endedHandler(data) {
      const eventData = data;
      eventData.videoId = this.playerInformation[this.videoId];
      document.body.dispatchEvent(new CustomEvent('videoInteraction', {
        detail: { originator: 'brightcove', interaction: 'video_completed' }
      }));
      this.eventsHandler.onEnded(eventData);

      this.bcPlayer.isEventViewed = {};
    }

    onReady() {
      if (this.eventsHandler.playOnLoaded) {
        this.bcPlayer.play();
      }
    }

    /**
    * createVideo: loads the requested video on the player.
    */
    async createVideo() {
      await this.loadBrightcoveScript();
      if (typeof videojs !== 'function') {
        return;
      }
      Object.keys(this.playerInformation).forEach(this.setAttribute.bind(this));
      this.bcPlayer = global.bc(this.player);
      this.bcPlayer.on('ended', this.endedHandler.bind(this));
      this.bcPlayer.on('play', this.playingHandler.bind(this));
      this.bcPlayer.on('pause', this.pausedHandler.bind(this));
      await new Promise((resolve) => {
        this.bcPlayer.on('ready', () => {
          this.onReady();
          resolve();
        });
      });
    }

    /**
    * loadBrightcoveScript: loads the Brightcove JavaScript needed for the player.
    */
    loadBrightcoveScript() {
      return new Promise((resolve) => {
        if (typeof global.videojs === 'function') {
          resolve();
          return;
        }

        if (global.define) {
          require(
            ['bc'],
            (brightcoveCallback) => {
              global.bc = brightcoveCallback;
              resolve();
            }
          );

          return;
        }

        const tag = document.getElementsByTagName('meta')[0];
        const script = document.createElement('script');

        script.async = true;
        script.src = this.brightcoveFilepath();
        script.type = 'text/javascript';
        script.onload = resolve;
        tag.parentNode.insertBefore(script, tag);
      });
    }

    /**
    * @public
    * dispose: destroy the video reference for brightcove.
    *
    */
    dispose() {
      if (!this.bcPlayer) {
        return;
      }
      this.bcPlayer.dispose();
    }

    /**
    * @public
    * pause: pauses the brightcove video.
    *
    */
    pause() {
      if (!this.bcPlayer) {
        return;
      }
      this.bcPlayer.pause();
    }

    /**
    * @public
    * play: plays the brightcove video.
    *
    */
    play() {
      if (!this.bcPlayer) {
        return;
      }
      this.bcPlayer.play();
    }

    /**
     * @public
     * createContainer: creates an HTML element needed by the Brightcove JavaScript to create the player.
     */
    static createContainer(id) {
      const videoElement = document.createElement('video');
      videoElement.id = id;
      videoElement.style.width = '100%';
      videoElement.style.height = '100%';
      videoElement.innerHTML = '';
      videoElement.className = 'video-js BrightcoveExperience BrightcoveExperienceID_4160 bc-player-HkxkXn9mf_default';
      videoElement.setAttribute('data-embed', 'default');
      videoElement.setAttribute('data-application-id', 'true');
      videoElement.setAttribute('controls', 'true');

      return videoElement;
    }
  }

  global.NewHomeSource.VideoPlayers.Brightcove = Brightcove;
}(window));
